import { render } from "./AdDetails.vue?vue&type=template&id=52a93597&scoped=true"
import script from "./AdDetails.vue?vue&type=script&lang=js"
export * from "./AdDetails.vue?vue&type=script&lang=js"

import "./AdDetails.vue?vue&type=style&index=0&id=52a93597&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a93597"]])

export default __exports__